export default "__VITE_ASSET__XZ23ITgg__"